import { render } from "./AppLayout.vue?vue&type=template&id=28e2a8de"
import script from "./AppLayout.vue?vue&type=script&lang=js"
export * from "./AppLayout.vue?vue&type=script&lang=js"

import "./AppLayout.vue?vue&type=style&index=0&id=28e2a8de&lang=css"

import exportComponent from "/Users/mq/Projects/siinadmin/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"AppLayout.vue"]])

export default __exports__